import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import { useIntl } from "react-intl";

const SelectMaximumPrice = ({ id = "select-maximum-price", ...rest }) => {
     const intl = useIntl();
     const userPrefs = useContext(UserPrefsContext);
     const label = intl.formatMessage
          ? intl.formatMessage({ id: "maximumPrice", defaultMessage: "Maximum Price" })
          : "Maximum Price";

     const optionNames = [
          "$500",
          "$1,000",
          "$1,500",
          "$2,000",
          intl.formatMessage({ id: "all", defaultMessage: "All" }),
     ];

     const optionValues = ["500", "1000", "1500", "2000", "all"];

     return (
          <Select
               id={id}
               value={userPrefs.get("chargerBudget")}
               label={label}
               optionNames={optionNames}
               optionValues={optionValues}
               handler={(e) => {
                    const val = e.target.value === "all" ? null : Number(e.target.value);
                    userPrefs.set({ chargerBudget: val });
               }}
               {...rest}
          />
     );
};

export default SelectMaximumPrice;

SelectMaximumPrice.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
};
